const isDevelopment = process.env.BUILD_ENV === 'development';
const __CLIENT_TYPE__ = process.env.CLIENT_TYPE;
const __API_JUNO__ = process.env.API_JUNO;
const __API_ALB_V2__ = process.env.API_ALB_V2;
const __API_LK__ = process.env.API_LK;
const __IS_LOCAL__ = process.env.IS_LOCAL_DEV;
const __YOTPO_API_KEY__ = isDevelopment
  ? 'H8YJ4tBeZCQjT0UJVvyfiCm7Dyl6v0UNCKwZXywm'
  : 'yRLOxOqElIsw88TIlZ1GZE9GxjFBP5oNzH49HEnC';
const __API_STORE__ = isDevelopment
  ? 'https://webapi-beta-preprod.lenskart.com'
  : 'https://webapi-beta.lenskart.com'; // process.env.API_STORE;
const __API_POS__ = isDevelopment
  ? 'https://apipos-preprod.lenskart.com'
  : 'https://apipos.lenskart.com';

const jsonPath =
  __IS_LOCAL__ === 'ON'
    ? `/locale/${__CLIENT_TYPE__}/:locale`
    : `https://static.lenskart.com/media/locale/${isDevelopment ? 'stage' : 'prod'
    }/${__CLIENT_TYPE__}/:locale`;

const environment = {
  development: {
    isProduction: false,
    assetsPath: '/',
  },
  production: {
    isProduction: true,
    assetsPath: `${__CLIENT_TYPE__ === 'mobile'
        ? 'https://static.lenskart.com/media/mobile/react/'
        : 'https://static.lenskart.com/media/desktop/js/dist-prod/'
      }`,
  },
}[process.env.BUILD_ENV || 'development'];

// Msite specific globals will go here.
const msiteGlobals = {
  maxShortList: { count: 50 },
  appXApiClients: ['android', 'ios'],
  recViewList: { noOfDisplayProducts: 11 },
  viewImagesList: ['frame_shape_id', 'frametype_id', 'frame_size_id'],
  filterCdnPath: 'https://static.lenskart.com/images/cust_mailer/',
  recCatList: { noOfCatIds: 5, noOfDisplayProducts: 10 },
  cmsCategoryArray: [
    'eyeglasses',
    'sunglasses',
    'power-sunglasses',
    'premium-eyeglasses',
    'contact-lenses',
  ],
};
//  ditto auth api
// const dittoSecretKey = '985b799a13ad811468ede9f20fc8bb2e802ce2a48712639ecccb7f2a39fb23f1abb027db2ac171823c77b0843877b2acad4c2e16ae0f3cfaf6b8a68881bcbeed';
// const dittoAccessKey = '864c62d7894d1f12';

// Msite specific api path will goes here.
const msiteApiPath = {
  homePageJson: `${jsonPath}/home.json`,
  verifyOtp: `${__API_JUNO__}/v2/customers/verifyOtp`,
  subCatApiUrl: `${__API_JUNO__}/v2/products/subcategory`,
  returnConfig: `${jsonPath}/return-config.json`,
  getOrdersList: `${__API_JUNO__}/v2/orders`,
  getOrdersListInv: `${__API_JUNO__}/v3/orders/aggregator/inventory`,
  returnReasons: `${__API_JUNO__}/v2/orders/return/reasons`,
  returnModes: `${__API_JUNO__}/v2/orders/return/methods`,
  createReturn: `${__API_JUNO__}/v2/orders`,
  validateServiceableAddress: `${__API_JUNO__}/v2/orders/return/serviceability`,
  nearbyStore: `${__API_JUNO__}/v2/utility/admin/store/nearbyAll`,
  itemReturnDetails: `${__API_JUNO__}/v2/orders/`,
  returnActions: `${__API_JUNO__}/v2/orders`,
  createRefund: `${__API_JUNO__}/v2/orders`,
  refundEstimate: `${__API_JUNO__}/v2/orders`,
  returnLabelStatus: `${__API_JUNO__}/v2/orders/return/return-label/`,
  paymentMethod: `${__API_JUNO__}/v3/payment-methods`,
  paymentOffers: `${__API_JUNO__}/v2/payments/offers/enabled`,
  posSeamlessLink: `${__API_POS__}/v1/order/seamless/sendLink`,
  getSalesmanDetails: `${__API_JUNO__}/v2/utility/salesman`,
  validateVpa: `${__API_JUNO__}/v2/payments/validateVpa`,
  upiTransactionStatus: `${__API_JUNO__}/v2/payments/`
};
// Common api paths will goes here for msite/desktop
let apiPath = {
  userSession: `${__API_JUNO__}/v2/sessions`,
  logOut: `${__API_JUNO__}/v2/sessions/logout`,
  albUserSession: `${__API_ALB_V2__}/v2/sessions`,
  redis: `${__API_JUNO__}/v2/utility/redis?keys=`,
  albRedis: `${__API_JUNO__}/v2/utility/redis?keys=`,
  redisConfig: `${jsonPath}/redis.json`,
  dataProduct: `${__API_JUNO__}/v2/products/product/`,
  albDataProduct: `${__API_ALB_V2__}/v2/products/product/`,
  dataProductUnSecure: `${__API_JUNO__}/v2/products/product/`,
  lensPackages: `${__API_JUNO__}/v2/products/product/`,
  lensPackageAndCoating: `${__API_JUNO__}/v2/products/product/buyoptions/group`,
  subscriptionDiscounts: `${__API_JUNO__}/v2/products/subscriptions/discount`,
  estimateDelivery: `${__API_JUNO__}/v2/products/product/`,
  categorySearch: `${__API_JUNO__}/v2/products/category/search/query/`,
  categorySearchFilter: `${__API_JUNO__}/v2/products/filters/query/`, // ?query=vincent
  // categorySearchFilter: `${__API_LK__}/v2/products/category/search/query/`, // ?query=vincent
  dataCategory: `${__API_JUNO__}/v2/products/category/`,
  albDataCategory: `${__API_JUNO__}/v2/products/category/`,
  categoryCarouselUrl: `${__API_JUNO__}/v2/products/carouselbanner?category=`,
  filterDataApi: `${__API_JUNO__}/v2/products/filters/`,
  homePageJson: `${jsonPath}/revamp_home.json`,
  mainNavigation: `${jsonPath}/navigation.json`,
  mobileNavigationJsonUrl: `${jsonPath}/navigation_menu.json`,
  userAuthenticate: `${__API_JUNO__}/v2/customers/authenticate`,
  userAddress: `${__API_JUNO__}/v2/customers/me/addresses/`,
  saveUpdateDitto: `${__API_JUNO__}/v2/utility/ditto/customer/`,
  lensOnlyShippinglocation: `${__API_LK__}/api/v1/shipping/location/`,
  deleteUserAddress: `${__API_JUNO__}/v2/customers/me/`,
  registerCustomer: `${__API_JUNO__}/v2/customers/register`,
  forgotPasswordToken: `${__API_JUNO__}/v2/customers/account/tokens`,
  campaignData: `${__API_JUNO__}/v2/utility/campaign`,
  socialAuth: `${__API_JUNO__}/v2/customers/socialauthenticate/`,
  updateCartItem: `${__API_JUNO__}/v2/carts/items/`,
  locationData: `${__API_JUNO__}/v2/utility/countrystate`,
  pincodeCheck: `${__API_JUNO__}/v2/utility/checkpincode/`,
  orderPayment: `${__API_JUNO__}/v2/orderpayment/`,
  // requestPaymentUrl: __API_LK___SECURE + '/me/index/requestPayment',
  applyGV: `${__API_JUNO__}/v2/carts/giftVoucher/`,
  storeCredit: `${__API_JUNO__}/v2/money/store-credits/`,
  applySC: `${__API_JUNO__}/v2/carts/`,
  cartApi: `${__API_JUNO__}/v2/carts`,
  albCartApi: `${__API_ALB_V2__}/v2/carts`,
  reOrderCartApi: `${__API_JUNO__}/v2/carts/recart/`,
  breadcrumb: `${__API_LK__}/me/index/breadcrumb?id=`,
  getUserInfo: `${__API_JUNO__}/v2/customers/me`,
  albGetUserInfo: `${__API_ALB_V2__}/v2/customers/me`,
  wishlist: `${__API_JUNO__}/v2/products/wishlist`,
  // usersSavedCards: `${__API_JUNO__}/v2/saved-cards`,
  checkDeliveryOption: `${__API_JUNO__}/v2/carts/expressdelivery/deliveryOptions?pincode=`,
  updateDeliveryOption: `${__API_JUNO__}/v2/carts/expressdelivery/updateDeliveryOption/`,
  oosSubscription: `${__API_JUNO__}/v2/products/product/oos-subscription`,
  saveShippingAddress: `${__API_JUNO__}/v2/carts/shippingAddress`,
  homeEyeCheckup: 'https://hto.lenskart.com/HTO/api/HTOService/slot',
  emailDitto: `${__API_JUNO__}/v2/utility/ditto/customer/mail`,
  enterMyPower: 'https://www.lenskart.com/instantpfulink.php',
  getOrderDetails: `${__API_JUNO__}/v2/orders/`,
  getOrdersList: `${__API_JUNO__}/v3/orders`,
  getOrderDetailsInv: `${__API_JUNO__}/v3/orders/aggregator/inventory?orderId=`,
  getOrdersListInv: `${__API_JUNO__}/v3/orders/aggregator/inventory`,
  getSavedPrescription: `${__API_JUNO__}/v2/prescriptions`,
  recentOrders: `${__API_JUNO__}/v2/orders/recentOrders`,
  latestOrder: `${__API_JUNO__}/v2/orders/latest/order`,
  uploadprescfile: `${__API_JUNO__}/me/index/uploadprescfile`,
  validateSession: `${__API_JUNO__}/v2/sessions/validate`,
  albValidateSession: `${__API_ALB_V2__}/v2/sessions/validate`,
  userLocation: `${__API_JUNO__}/v2/utility/configurations/location?ip=`,
  albUserLocation: `${__API_JUNO__}/v2/utility/configurations/location?ip=`,
  varnishApi: `${__API_LK__}/ajax/index/dummyvar`,
  dittoProfile: `${__API_JUNO__}/v2/utility/ditto/customer/`,
  changePassword: `${__API_JUNO__}/v2/customers/account/resetpassword`,
  giftVoucherBalance: `${__API_JUNO__}/v2/money/gift-vouchers/code?giftVoucherCode=`,
  mobileLoginAccountInfo: `${__API_JUNO__}/v2/customers/accountsInfo`,
  editNeft: `${__API_JUNO__}/v2/orders/neft/savedetails`,
  resetPassword: `${__API_JUNO__}/juno-customer/v2/customers/account/forgotpassword`,
  mobileLoginSendOTP: `${__API_JUNO__}/v2/customers/sendOtp`,
  mobileLoginAuthenticateMobileUser: `${__API_JUNO__}/v2/customers/authenticate/mobile`,
  magentoCategory: `${__API_JUNO__}/me/index/carouselbanner?category=`,
  mobileEmailFetch: `${__API_JUNO__}/v2/customers/accounts?telephone=`,
  mobileEmailLink: `${__API_JUNO__}/v2/customers/accountVerification/sendEmail`,
  cmsPages: 'https://www.lenskart.com/me/catalog/cmsPage/id/',
  captchaUrl: `${__API_LK__}/me/index/getcaptcha/`,
  countryCode: `${__API_STORE__}/country/`,
  apiCampaign: `${__API_STORE__}/campaign?client=${__CLIENT_TYPE__ === 'mobile' ? 'msite' : 'desktop'
    }`,
  dittoAuth: `${__API_JUNO__}/v2/utility/ditto/customer/authentication/token/`,
  reviewProduct: `${__API_JUNO__}/v2/products/product/`,
  generateOtp: `${__API_JUNO__}/v2/utility/otp`,
  yotpoSiteReview: `https://api.yotpo.com/products/${__YOTPO_API_KEY__}/yotpo_site_reviews/bottomline`,
  checkWhatsappConsent: `${__API_JUNO__}/v2/customers/checkWhatsAppOpingStatus`,
  setWhatsappConsent: `${__API_JUNO__}/v2/customers/whatsAppOpting`,
  // frameSize: `https://lenskart-${isDevelopment ? 'prod' : 'prod'}.firebaseapp.com/api/v1/frame-size/calculate`,
  frameSize: `https://lenskart-${isDevelopment ? 'prod' : 'prod'
    }.firebaseapp.com/api/v1/frame-size/calculate`,
  storeFrameSize: `https://lenskart-${isDevelopment ? 'stage-e9bdd' : 'prod'
    }.firebaseapp.com/api/v1/frame-size/upload_image`,
  categoryConfigJson: `https://lenskart-${isDevelopment ? 'stage-e9bdd' : 'prod'}.firebaseapp.com/api/v1/static/category-config`,
  getCustomerInfo: `${__API_JUNO__}/v2/customers/info/`,
  storeApi: `${__API_STORE__}`,
  getCardOffers: `${__API_JUNO__}/v2/payments/offers/enabled`, // use it for getCardOffers local env
  applyOfferMock: '/mock-api/applyOffer', // for mock
  applyOffer: `${__API_JUNO__}/v2/carts/paymentOffer`, // use it for getCardOffers local env
  // usersSavedCards: '/mock-api/savedCards',
  usersSavedCards: `${__API_JUNO__}/v2/saved-cards/`,
  removeOfferMock: '/mock-api/removeOffer', // for mock
  removeOffer: `${__API_JUNO__}/v2/carts/paymentOffer/`,
  // paymentMethod: '/mock-api/paymentMethods',
  paymentMethod: `${__API_JUNO__}/v4/payment-methods`,
  htoPageJson: `${jsonPath}/hto.json`,
  validateUserLocation: `${__API_JUNO__}/HTO/api/HTOService`,
  htoBookNowOrder: `${__API_JUNO__}/HTO/api/HTOService`,
  qrPaymentsApi: `${__API_JUNO__}/v2/payments/`,
  preSalesDualLogin: `${__API_JUNO__}/v2/customers/dualLogin`,
  localeConfigPath: `${__IS_LOCAL__ === 'ON' ? '/locale/localeConfig.:locale.json' : `https://static.lenskart.com/media/locale/${isDevelopment ? 'stage' : 'prod'}/localeConfig.:locale.json`}`,
  downloadUploadedPrescription: `${__API_JUNO__}/v2/utility/customer/prescriptions/download/`
};

apiPath = __CLIENT_TYPE__ === 'mobile' ? Object.assign(apiPath, msiteApiPath) : apiPath;

let config = Object.assign(
  {
    host: process.env.HOST || 'localhost',
    port: process.env.PORT || 3000,
    apiHost: process.env.APIHOST || 'localhost',
    apiPort: process.env.APIPORT,
    app: {
      title: 'Lenskart.com® - First Eyeglasses Frame FREE',
      description:
        'Shop online for Sunglasses, Eyeglasses and Contact Lenses for men &amp; women and Get upto 50% Flat Discount at lenskart.com.  ✓FREE shipping ✓Cash on Delivery ✓14 Days Return.​',
      head: {
        titleTemplate: '%s',
      },
    },
    categoryPageSize: 15,
    apiPath,
    rbiMarketPlaceConfig: {
      type: __CLIENT_TYPE__,
      defaultLogo: 'https://static.lenskart.com/media/mobile/images/lkLogo.svg',
    },
    ditto: {
      serverUrl: 'https://vto.lenskart.api.ditto.com',
      accessKeyId: '',
      signature: '',
      modelDittoId: 'ditto_model_female_04',
      modelDittoSignature: '',
      sku: '122548',
      disableScale: true,
      vtoUrl: 'https://vto.lenskart.api.ditto.com/api/1.3/dittos/',
      faServerUrl: 'https://face.lenskart.api.ditto.com',
      replaceShareDittoUrlPrefix: !isDevelopment,
    },
    sixOversix: {
      options: {
        fullPage: true,
        width: '100vw',
        themeColor: '#5FB8E3',
      },
      clientId: isDevelopment
        ? '093f4b80946e12dfd1f5a3552fd5acbf'
        : 'aef53fd8f1d4fe16b40e085cce94ed35',
    },
    defaultFrameCategory: {
      eyeglasses: '/eyeglasses/brands/vincent-chase-eyeglasses.html#filter_frame_size_id%3D',
      sunglasses: '/sunglasses/promotions/vc-new-arrivals.html#filter_frame_size_id%3D',
    },
    searchBarConfig: {
      url: 'https://search.unbxdapi.com/{0}/autosuggest?q=',
      siteName: 'lenskart_com-u1418736834941',
      APIKey: '6c1aa3ba216de83b8340d2d4d891d309',
      inFields: {
        count: 2,
      },
      topQueries: {
        count: 5,
      },
      keywordSuggestions: {
        count: 2,
      },
      popularProducts: {
        count: 5,
      },
    },
    yotpoConfig: {
      apiKey: __YOTPO_API_KEY__,
      instaGalleries: {
        pdp: isDevelopment ? '5cd2e4b093bf900cc16e06c3' : '5cd56a15a230aa3b9199f193',
        home: isDevelopment ? '5cc82cae6830580008ec0594' : '5cc6ae7593bf9010d734bc9d',
        shop: isDevelopment ? '5cd3edb858bdd30009dca8dc' : '5cd56a30f1b75c389da04c81',
      },
    },
    jsonPath,
  },
  environment
);
('#if CLIENT_TYPE === "mobile"'); // eslint-disable-line
config = Object.assign(config, { msiteGlobals });
('#endif'); // eslint-disable-line

module.exports = config;
